import IState from '../models/IState';
import { createSelector } from "reselect";
import moment from 'moment'
import config from '../../helpers/config.helper';

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

const stateSensorData = (state: IState) => state.sensorData.sensorDataList.datas;

export const allSensorData = createSelector(
    stateSensorData,
    (datas) => {
        if (datas) {
            if (datas.AQSData) {
                datas.AQSData.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            } 
            else if (datas.FDSData) {
                datas.FDSData.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            }
            else if (datas.AQS2Data) {
                datas.AQS2Data.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            }
            else if (datas.FDS2Data) {
                datas.FDS2Data.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            }
            else if (datas.TIoTData) {
                datas.TIoTData.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            }
            else if (datas.PSData) {
                datas.PSData.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            }
            else if (datas.AQS3Data) {
                datas.AQS3Data.map((item: any) => {
                    item.MeasurementTime = moment(new Date(item.MeasurementTime)).format(dateTimeFormat)
                    item.CreateTime = moment(new Date(item.CreateTime)).format(dateTimeFormat)
                    item.Mode = item.Mode === 1 ? 'Measurement' : 'Test'
                    return item
                });
            }

            return datas;
        }
        return [];
    }
)

